import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserAccountApi } from '../../theme/services/sdk';


@Injectable()
export class CanActivateViaAuthGuard implements CanActivate {

    constructor(protected user:UserAccountApi, private router: Router) {}

    canActivate() {
        if(this.user.isAuthenticated()){
            return true;
        }else{
            this.router.navigate(['login']);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/guards/canactivate.guard.ts